<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.rg_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.rg_vietnamese_name">
                      <el-input v-model="mData.tableRules.dataSearch.value['ten.vi']" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.rg_english_name">
                      <el-input v-model="mData.tableRules.dataSearch.value['ten.en']" clearable></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8">
            <div class="text-left mb-0">
              <b-row>
            <b-col md="4">
              <el-select
                v-model="mData.tableRules.dataSearch.value.loai"
                :placeholder="aLang.rg_object_reflection"
                :disabled="mData.viewMode == 'detail'"
                @change="fn_tableSearch()"
                clearable
                filterable
              >
                <el-option
                  v-for="item in mData.dataDefault.loaiNhomPhanHois"
                  :key="item.code"
                  :label="item.text"
                  :value="item.code"
                ></el-option>
              </el-select>
            </b-col>
            <b-col md="4">
              <el-select
                v-model="mData.tableRules.dataSearch.value.chuyen_tcqltt"
                :placeholder="aLang.rg_move_TCQLTT"
                :disabled="mData.viewMode == 'detail'"
                @change="fn_tableSearch()"
                clearable
                filterable
              >
                <el-option
                  v-for="item in mData.dataDefault.trangThaiChuyen"
                  :key="item.code"
                  :label="item.text"
                  :value="item.code"
                ></el-option>
              </el-select>
            </b-col>
            </b-row>
            </div>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <el-button @click="fn_handle('create')" type="info" v-if="aRole('Admin')" plain>{{aLang.c_create}}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="thu_tu"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.rg_order"
            width="100"
            align="center"
          ></el-table-column>         
          <el-table-column prop="ten_loai" :sortable="mData.tableRules.allowSorting" label="Đối tượng phản ánh" min-width="150"></el-table-column>
          <el-table-column
            prop="ten.vi"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.rg_vietnamese_name"
            width="auto"
            min-width="200"
          ></el-table-column>
          <el-table-column
            prop="ten.en"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.rg_english_name"
            width="auto"
            min-width="200"
          ></el-table-column>
           <el-table-column
            prop="chuyen_tcqltt"
            :label="aLang.rg_move_TCQLTT"
            :sortable="mData.tableRules.allowSorting"
            width="150"
            align="center"            
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.chuyen_tcqltt"
                @change="fn_changeSelected(scope.row.id,scope.row.chuyen_tcqltt)"                
              ></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import NhomPhanHoiModel from "./NhomPhanHoiModel";
import NhomPhanHoiApi from "../../../moduleApi/NhomPhanHoiApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "NhomPhanHoi", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(NhomPhanHoiModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          loaiNhomPhanHois: NhomPhanHoiModel.loaiNhomPhanHoi,
          trangThaiChuyen: NhomPhanHoiModel.trangThaiChuyen
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters + (this.mData.tableRules.filters ? "&" : "") + "loai:nin:kdl" 
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await NhomPhanHoiApi.list(dataFilter);
      for (var itemdata in res.result) {
        if (
          this.mData.dataDefault.loaiNhomPhanHois.find(
            item => item.code === res.result[itemdata].loai
          )
        ) {
          res.result[
            itemdata
          ].ten_loai = this.mData.dataDefault.loaiNhomPhanHois.find(
            item => item.code === res.result[itemdata].loai
          ).text;
        } else {
          res.result[itemdata].ten_loai = "";
        }
      }
      this.mData.tableRules.data = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await NhomPhanHoiApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id, disable) {
      await NhomPhanHoiApi.disable(id, disable);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {          
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    async fn_changeSelected(id,trangThai) {
      let data = {
        id: id,
        chuyen_tcqltt: trangThai
      };
      await NhomPhanHoiApi.update(data);
      this.fn_initTable();
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {},

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
